import {
  Button,
  Col,
  Descriptions,
  Divider,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {HeaderPrintForm} from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppSelector} from "redux/hooks";
import "./config";
import {columns} from "./config";
import "./BillModal.scss";
import {
  convertIosDateToString,
  convertIosStringToDate2,
  formatDateToString,
  formatToCurrencyTypeToFixed,
  getAge,
} from "helper/common";
import {CURRENCY_LOCALE, FORMAT_TIME} from "types/enums";
import {InfoItem} from "components/common/PrintForm";
import dayjs from "dayjs";
const BillModal = props => {
  const {closeModal, getDetailPrescription} = props;
  const printRef = useRef<any>();
  const salePrescription = useAppSelector(
    state => state.medicineStore.salePrescription
  );

  const detailPhieu = getDetailPrescription();
  console.log("🚀 ~ BillModal ~ detailPhieu:", detailPhieu);

  const fields1 = [
    {label: "Họ và tên", value: detailPhieu?.prescriptionDto?.hoTen},
    {
      label: "Ngày sinh",
      value: formatDateToString(
        detailPhieu?.prescriptionDto?.ngaySinh,
        FORMAT_TIME.dayFull
      ),
    },
    {label: "Tuổi", value: getAge(detailPhieu?.prescriptionDto?.ngaySinh)},
    {
      label: "Giới tính",
      value: detailPhieu?.prescriptionDto?.gioiTinh == "NA" ? "Nam" : "Nữ",
    },
    {label: "Điện thoại", value: detailPhieu?.prescriptionDto?.dienThoai},
  ];
  const fields2 = [
    {label: "Mã bệnh nhân", value: detailPhieu?.prescriptionDto?.maBenhNhan},
    {label: "Mã phiếu khám", value: detailPhieu?.prescriptionDto?.maKB},

    {label: "Bác sĩ", value: detailPhieu?.prescriptionDto?.tenBacSy},
    {
      label: "Thời gian bán",
      value: formatDateToString(
        detailPhieu?.prescriptionDto?.thoiGianBan,
        FORMAT_TIME.dateTime
      ),
    },
    // {label: "Địa chỉ", value: detailPhieu?.prescriptionDto?.diaChi},
  ];
  const fields3 = [
    {label: "Địa chỉ", value: detailPhieu?.prescriptionDto?.diaChi},
  ];
  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="bill-modal-hoa-don-thuoc">
      <div className="print-modal-hoa-don-thuoc" ref={printRef}>
        <HeaderPrintForm></HeaderPrintForm>
        <div>
          <InfoItem
            fields1={fields1}
            fields2={fields2}
            fields3={fields3}
            idBenhNhan={detailPhieu?.prescriptionDto?.maBenhNhan}
            title={"HOÁ ĐƠN THUỐC"}
            isChiefComplant={false}
            qr={false}
            // spanLeft={10}
            // spanRight={14}
          />
          <div className="container2" style={{marginBottom: 12}}>
            <Row>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 20,

                  marginBottom: 12,
                }}
              ></Typography.Text>
            </Row>
            <div className="table-print">
              <Table
                bordered
                columns={columns}
                dataSource={detailPhieu?.listPrescriptionSalesDto}
                pagination={false}
              ></Table>
            </div>
          </div>

          <div className="container2" style={{marginBottom: 12}}>
            <Row>
              <Col sm={8} md={8} xl={8}>
                <div>
                  Số tiền miễn giảm:{" "}
                  <span className="value">
                    {formatToCurrencyTypeToFixed(
                      detailPhieu?.prescriptionDto?.giamGia,
                      0,
                      CURRENCY_LOCALE.TYPE_DE
                    )}
                    đ
                  </span>
                </div>
                <div>
                  Lý do miễn giảm: {detailPhieu?.prescriptionDto?.lyDoGiam}
                </div>
              </Col>
              <Col sm={16} md={16} xl={16}>
                <Space
                  split={<Divider type="vertical" />}
                  style={{width: "100%", justifyContent: "flex-end"}}
                >
                  <div>
                    <span className="label">Tổng tiền:</span>{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailPhieu?.prescriptionDto?.tongTien,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                  <div>
                    <span className="label">Tổng GT giảm:</span>{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailPhieu?.prescriptionDto?.giamGia,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                  <div>
                    <span className="label">Thành tiền:</span>{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailPhieu?.prescriptionDto?.thanhTien,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>

          <Sign
            nguoiThucHien={detailPhieu?.prescriptionDto?.nguoiBan}
            label="Người bán thuốc"
            time={formatDateToString(
              detailPhieu?.prescriptionDto?.thoiGianBan,
              null
            )}
          ></Sign>
        </div>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            onAfterPrint={closeModal}
            bodyClass="bill-modal-hoa-don-thuoc"
          />
        </Space>
      </Row>
    </div>
  );
};
export default BillModal;
